<template>
<div>
    <div class="toolbar">
        <el-row>
            <el-col :span="24" :md="24" :sm="24" :xs="24" justify="end">
                <template>
                    <el-select @change="handleChangeType" v-model="selectedMessageTypeField" placeholder="Message Type" style="width:130px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                        <el-option
                        v-for="item in messageTypeField"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    
                    <el-select v-model="selectedFilter" placeholder="Filter By" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                        <el-option
                        v-for="itm in filterBy"
                        :key="itm.value"
                        :label="itm.label"
                        :value="itm.value">
                        </el-option>
                    </el-select>
                    <el-select v-model="selectedField" placeholder="Select Field" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                        <el-option
                        v-for="item in searchFields"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- <el-date-picker class="mr-5 mb-10"
                        style="top: 2px !important; width:220px;"
                        v-model="selectedStartDate"
                        range-separator="to"
                        size="mini"
                        type="daterange"
                        placeholder="Pick a day">
                    </el-date-picker> -->
                    <el-input
                        style="width:200px;"
                        class="mb-10"
                        size="mini"
                        prefix-icon="el-icon-search"
                        placeholder="Search data"
                        clearable
                        v-model="filterSearch">
                    </el-input>
                    <el-button-group class="mr-10 ml-10">
                        <el-button type="primary" round size="mini" :loading="loadingReportTable" class="animated fadeInRight" style="background-color: #0047FF;" @click="changeFilter">
                            Set Filter and Search
                        </el-button>
                    </el-button-group>
                </template>
            </el-col>
        </el-row>
    </div>
    <br>
    <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <!-- <div>
                <span>Send : </span><span>Delivered : </span><span>Read : </span>
            </div> -->
            <el-row>
                <el-col>
                    <el-card shadow="card-shadow--small">
                        <el-pagination
                            background
                            prev-text="Prev"
                            next-text="Next"
                            layout="prev, pager, next"
                            :page-size="10"
                            @current-change="paginateReport"
                            :current-page="currentPage"
                            :total="totalData">
                        </el-pagination><br>
                        <div class="group-list scrollable only-y">
                            <template>
                                    <el-table
                                    v-loading="loadingReportTable"
                                    :data="tableData"
                                    :span-method="objectSpanMethod"
                                    style="width: 100%; margin-top: 20px">
                                    <el-table-column
                                        header-align="center"
                                        prop="no"
                                        label="No"
                                        width="70">
                                    </el-table-column>
                                    <el-table-column
                                        header-align="center"
                                        prop="id"
                                        label="WABA ID"
                                        width="180">
                                    </el-table-column>
                                    <el-table-column
                                        header-align="center"
                                        prop="name"
                                        label="WABA Name"
                                        width="260">
                                    </el-table-column>
                                    <el-table-column
                                        header-align="center"
                                        prop="type"
                                        label="Type"
                                        width="100">
                                    </el-table-column>
                                    <el-table-column header-align="center" label="Business Initiated">
                                        <el-table-column
                                            prop="bi"
                                            label="Sessions"
                                            width="120">
                                        </el-table-column>
                                        <el-table-column
                                            v-if="selectedMessageTypeField == 'monthly'"
                                            prop="bi_l7"
                                            label="L7"
                                            width="120">
                                        </el-table-column>
                                        <el-table-column
                                         v-if="selectedMessageTypeField == 'monthly'"
                                            prop="bi_avg_l7"
                                            label="Avg L7"
                                            width="120">
                                            <template slot-scope="props">
                                                <p >{{ parseInt(props.row.bi_avg_l7)}}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            prop="bi_revenue"
                                            label="Revenue"
                                            width="150">
                                            <template slot-scope="props">
                                                <p style="font-weight:bold;">{{ !props.row.bi_revenue ? '-':formatPrice(props.row.bi_revenue)}}</p>
                                            </template>
                                        </el-table-column>
                                    </el-table-column>
                                    <el-table-column header-align="center" label="User Initiated">
                                        <el-table-column
                                            prop="ui"
                                            label="Sessions"
                                            width="120">
                                        </el-table-column>
                                         <el-table-column
                                            v-if="selectedMessageTypeField == 'monthly'"
                                            prop="ui_l7"
                                            label="L7"
                                            width="120">
                                        </el-table-column>
                                        <el-table-column
                                         v-if="selectedMessageTypeField == 'monthly'"
                                            prop="ui_avg_l7"
                                            label="Avg L7"
                                            width="120">
                                            <template slot-scope="props">
                                                <p >{{ parseInt(props.row.ui_avg_l7)}}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            prop="ui_revenue"
                                            label="Revenue"
                                            width="150">
                                                <template slot-scope="props">
                                                <p style="font-weight:bold;">{{ !props.row.ui_revenue ? '-':formatPrice(props.row.ui_revenue)}}</p>
                                            </template>
                                        </el-table-column>
                                    </el-table-column>
                                    <el-table-column header-align="center" label="Conversation Total">
                                        <el-table-column
                                            prop="conversation_total"
                                            label="Sessions"
                                            width="120">
                                        </el-table-column>
                                         <el-table-column
                                            v-if="selectedMessageTypeField == 'monthly'"
                                            prop="conversation_total_l7"
                                            label="L7"
                                            width="120">
                                        </el-table-column>
                                        <el-table-column
                                         v-if="selectedMessageTypeField == 'monthly'"
                                            prop="conversation_total_avg_l7"
                                            label="Avg L7"
                                            width="120">
                                            <template slot-scope="props">
                                                <p >{{ parseInt(props.row.conversation_total_avg_l7)}}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            prop="revenue_total"
                                            label="Rupiah"
                                            width="150">
                                                <template slot-scope="props">
                                                <p style="font-weight:bold;">{{ !props.row.revenue_total ? '-':formatPrice(props.row.revenue_total)}}</p>
                                            </template>
                                        </el-table-column>
                                    </el-table-column>
                                    <el-table-column header-align="center" label="Traffic">
                                        <el-table-column
                                            prop="send"
                                            label="Send"
                                            width="120">
                                        </el-table-column>
                                        <el-table-column
                                            prop="delivered"
                                            label="Delivered"
                                            width="120">
                                        </el-table-column>
                                    </el-table-column>
                                    <el-table-column
                                        header-align="center"
                                        fixed="right"
                                        label="Action"
                                        width="100">
                                        <template slot-scope="scope">
                                            <el-button size="small" @click="detailActiveBusiness(scope.row)">Detail</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </div><br/>
                        <el-pagination
                            background
                            prev-text="Prev"
                            next-text="Next"
                            layout="prev, pager, next"
                            :page-size="10"
                            @current-change="paginateReport"
                            :current-page="currentPage"
                            :total="totalData">
                        </el-pagination>
                    </el-card>
                </el-col>
            </el-row>
        </el-col>
    </el-row>
    <el-dialog :close-on-click-modal="false" :title="`WABA ID : ${idDetail}`" :visible.sync="modalDetail" style="width: 100%;">
		<template>

			<!-- <el-select style="width: 40%;" v-model="phoneNumberSessionSelected" @change="handleChangeSelectedSession" filterable placeholder="Select Country">
				<el-option
				v-for="(item,i) in phoneNumberSession" :key="i"
				:label="`+${item.label}`"
				:value="item.value">
				</el-option>
			</el-select> -->
			<div style="margin: 30px 0;"></div>
            <el-table
                :data="dataDetail"
                v-loading="loadingDetail"
                :span-method="objectSpanMethodDetail"
                style="width: 100%;">
                <el-table-column
                    prop="phone_number"
                    label="Phone Number"
                    width="180">
                    <template slot-scope="props">
                        <p>{{ '+' + props.row.phone_number}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="masking_name"
                    label="Masking Name"
                    width="250">
                </el-table-column>
                <el-table-column
                    header-align="center"
                    prop="type"
                    label="Type"
                    width="100">
                </el-table-column>
                <el-table-column header-align="center" label="Business Initiated">
                    <el-table-column
                        prop="bi"
                        label="Sessions"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        v-if="selectedMessageTypeFieldDetail == 'monthly'"
                        prop="bi_l7"
                        label="L7"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        v-if="selectedMessageTypeFieldDetail == 'monthly'"
                        prop="bi_avg_l7"
                        label="Avg L7"
                        width="120">
                        <template slot-scope="props">
                            <p >{{ parseInt(props.row.bi_avg_l7)}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="bi_revenue"
                        label="Revenue"
                        width="120">
                        <template slot-scope="props">
                            <p style="font-weight:bold;">{{ !props.row.bi_revenue ? '-':formatPrice(props.row.bi_revenue)}}</p>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column header-align="center" label="User Initiated">
                    <el-table-column
                        prop="ui"
                        label="Sessions"
                        width="120">
                    </el-table-column>
                        <el-table-column
                        v-if="selectedMessageTypeFieldDetail == 'monthly'"
                        prop="ui_l7"
                        label="L7"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        v-if="selectedMessageTypeFieldDetail == 'monthly'"
                        prop="ui_avg_l7"
                        label="Avg L7"
                        width="120">
                        <template slot-scope="props">
                            <p >{{ parseInt(props.row.ui_avg_l7)}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="ui_revenue"
                        label="Revenue"
                        width="120">
                            <template slot-scope="props">
                            <p style="font-weight:bold;">{{ !props.row.ui_revenue ? '-':formatPrice(props.row.ui_revenue)}}</p>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column header-align="center" label="Conversation Total">
                    <el-table-column
                        prop="conversation_total"
                        label="Sessions"
                        width="120">
                    </el-table-column>
                        <el-table-column
                        v-if="selectedMessageTypeFieldDetail == 'monthly'"
                        prop="conversation_total_l7"
                        label="L7"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        v-if="selectedMessageTypeFieldDetail == 'monthly'"
                        prop="conversation_total_avg_l7"
                        label="Avg L7"
                        width="120">
                        <template slot-scope="props">
                            <p >{{ parseInt(props.row.conversation_total_avg_l7)}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="revenue_total"
                        label="Rupiah"
                        width="120">
                            <template slot-scope="props">
                            <p style="font-weight:bold;">{{ !props.row.revenue_total ? '-':formatPrice(props.row.revenue_total)}}</p>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column header-align="center" label="Traffic">
                    <el-table-column
                        prop="send"
                        label="Send"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        prop="delivered"
                        label="Delivered"
                        width="120">
                    </el-table-column>
                </el-table-column>
            </el-table>
		</template>
	</el-dialog>
</div>
</template>
<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')
export default {
    name: 'Report',
    components: {
  	},
    props: {
        // months:{
        //     type: Array
        // },
        dataActive:{
            type: Array
        },
        total :{
            type: Number
        },
        loadingData:{
            type: Boolean
        },
        type:{
            type: String
        },
        date: {
            type: Array
        },
        filter: {
            type: String
        },
        field: {
            type: String
        }
    },
    data() {
        return {
            optionsMonths: [],
            selectedFieldCompare: "waba",
            selectedTypeField:"conversation",
            input1: "",
            input2: "",
            filterChart2: 'phone',
            dataChart1: {
                loading: false,
				labels: [],
				datasets: [{
					label: '',
					data: [],
					fill: false,
                    borderColor: 'rgb(75, 192, 192)',
                    tension: 0.1
				},
                {
					label: '',
					data: [],
					fill: false,
                    borderColor: 'rgb(255, 99, 132)',
                    tension: 0.1
				}]
			},
            dataChart2: {
                loading: false,
				labels: [],
				datasets: [
                    {
                        label: '',
                        data: [],
                        fill: false,
                        borderColor: 'rgb(255, 99, 132)',
                        tension: 0.1
                    }
                ]
			},
            options: {
				scales: {
					y: {
						beginAtZero: true
					}
				},
				segmentShowStroke: false,
				responsive: true,
				legend: {
					onClick: function(event){
						// console.log(event)
					},
					position: 'bottom',
				},
				title: {
					display: true,
					text: 'Conversation'
				},
				animation: {
					animateScale: true,
					animateRotate: true
				},
				plugins: {
					labels: {
						// render 'label', 'value', 'percentage', 'image' or custom function, default is 'percentage'
						render: 'value',

						// font size, default is defaultFontSize
						fontSize: 12,

						// font color, can be color array for each data or function for dynamic color, default is defaultFontColor
						fontColor: '#ffff',

						// font style, default is defaultFontStyle
						fontStyle: 'normal',

						// font family, default is defaultFontFamily
						fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",

						// position to draw label, available value is 'default', 'border' and 'outside'
						// bar chart ignores this
						// default is 'default'
						position: 'default',

					}
				},
				hover: {
					onHover: function(e,i) {
					let el = document.getElementsByClassName("chartjs");
					el[0].style.cursor = i[0] ? "pointer" : "default";
					}
				},
				onClick : (event, item)=>{
				// console.log('item on bar chart',item[0]._index || null);
				let id = event.path[0].getAttribute('id')
                    // if (id == 'chart-1') {
                    //     this.detailChart(id,item[0]._index)
                    // }
				}
			},
            idDetail:'',
            modalDetail: false,
            valueDetail: {},
            dataDetail:[
                // {
                //     phone_number: '6281110555777',
                //     masking_name: 'Trial 9',
                //     waba_name: 'Trial 9',
                //     type: 'Meta',
                //     case: `BI (25%), UI (75%)`,
                //     session: 100,
                //     revenue: 378.54
                // },
                // {
                //     phone_number: '6281110555777',
                //     masking_name: 'Trial 9',
                //     waba_name: 'Trial 9',
                //     type: 'DKD',
                //     case: `BI (25%), UI (50%), CBP (25%)`,
                //     session: 100,
                //     revenue: 378.54
                // }
            ],
            loadingDetail: false,
            activeTab: 'index',
            loadingBtnInq: false,
            // asyncComponent: 'peity',
            selectedStartDate: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD")
            ],
            selectedStartDate1: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD")
            ],
            selectedStartDate2: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD")
            ],
            searchStartDate: [
                moment().subtract(1,"day").hours(0).minutes(0).seconds(0).format(),
                moment().hours(0).minutes(0).seconds(0).format()
            ],
            selectedFilter: moment().format("YYYY-MM"),
            searchNumber: '',
            searchField: '',
            searchTerm: '',
            // selectedEndDate: '',
            filterSearch: '',
            number:[],
            currentPage: 1,
            loadingReportTable: false,
            filterBy: this.optionsMonths,
            filterByCompare: [
                { value: "phone", label: "Phone Compare" },
                { value: "date", label: "Date Compare" }
            ],
            searchFields: [
                { value: "phone_number", label: "Phone Number" },
                { value: "waba_id", label: "WABA ID " }
            ],
            messageTypeField: [
                { value: "monthly", label: "Monthly" },
                { value: "quarter_years", label: "Quarter Years" },
                { value: "half_years", label: "Half Years" },
            ],
            sessionTypeField: [
                { value: "all", label: "All" },
                { value: "charge", label: "Charge" },
                { value: "not_charge", label: "Not Charge" },
            ],
            typeField: [
                { value: "conversation", label: "Conversation" },
                { value: "ui", label: "User Initiate" },
                { value: "bi", label: "Business Initiate" },
                { value: "revenue", label: "Revenue" }
            ],
            selectedMessageTypeField: "monthly",
            selectedMessageTypeFieldDetail: "",
            selectedSessionTypeField: "all",
            tableData: [
                // {
                //     no: '1',
                //     id: '305490440128441',
                //     name: 'Trial 9',
                //     type: 'Meta',
                //     case: `BI (25%), UI (75%)`,
                //     session: 100,
                //     revenue: 378.54
                // },
                // {
                //     no: '1',
                //     id: '305490440128441',
                //     name: 'Trial 9',
                //     type: 'DKD',
                //     case: `BI (25%), UI (50%), CBP (25%)`,
                //     session: 100,
                //     revenue: 378.54
                // }
            ],
            loadingExport: false,
            selectedYear: moment().format("YYYY"),
            //selectedMonth: moment().format("M"),
            selectedPhone: '',
            selectedField: 'waba_id',
            dataMessages: [],
            totalData: 0,
            fbbmStatus: {
                sent: 0,
                delivered: 0
            },
            status: {
                read:0,
                sent:0,
                failed:0,
                delivered:0,
                invalid: 0,
            },
            usage: this.statusUsage
        }
    },
    methods: {
        handleChangeType(val){
            // this.loadingReportTable = true
            switch (val) {
                case "monthly":
                    this.filterBy = this.optionsMonths
                    this.selectedFilter = moment().format("YYYY-MM")
                    break;
                case "quarter_years":
                    this.filterBy = [
                        { value: "1", label: "Q1" },
                        { value: "2", label: "Q2" },
                        { value: "3", label: "Q3" },
                        { value: "4", label: "Q4" }
                    ]

                    this.selectedFilter = "1"
                    break;
                case "half_years":
                    this.filterBy = [
                        { value: "1", label: "H1" },
                        { value: "2", label: "H2" }
                    ]
                    this.selectedFilter = "1"
                    break;
                default:
                    break;
            }

            // setTimeout(() => {
            //     this.loadingReportTable = false
            // }, 300);
        },
        handleChangeCompare(val){
            this.dataChart1.loading = true
            this.dataChart2.loading = true
            if (val == 'date') {
                this.dataChart1.datasets.splice(1,1)
            }
            else{
                this.dataChart1.datasets.push(
                    {
					label: '',
					data: [],
					fill: false,
                    borderColor: 'rgb(255, 99, 132)',
                    tension: 0.1
				})
            }

            setTimeout(() => {
                this.dataChart1.loading = false
                this.dataChart2.loading = false
            }, 200);

            // this.dataChart1.loading = false
            //     this.dataChart2.loading = false

        },
        tabClick(tab){
            console.log(tab);
        },
        async detailActiveBusiness(val){
            this.valueDetail = val
            this.idDetail = val.id
            this.modalDetail = true
            await this.loadDetail(this.idDetail)
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex < 3) {
            if (rowIndex % 3 === 0) {
            return {
                rowspan: 3,
                colspan: 1
            };
            } else {
            return {
                rowspan: 0,
                colspan: 0
            };
            }
        }

        // if (columnIndex == 16 || columnIndex == 17) {
        //     // console.log("row",row);
        //     // console.log("column",column);
        //     // console.log("rowIndex",rowIndex);
        //     if (rowIndex > 0 && rowIndex % 1 === 0) {
        //     return {
        //         rowspan: 2,
        //         colspan: 1
        //     };
        //     } else {
        //     return {
        //         rowspan: 1,
        //         colspan: 1
        //     };
        //     }
        // }

        if (columnIndex > 17 ) {
            if (rowIndex % 3 === 0) {
            return {
                rowspan: 3,
                colspan: 1
            };
            } else {
            return {
                rowspan: 0,
                colspan: 0
            };
            }
        }
      },
      objectSpanMethodDetail({ row, column, rowIndex, columnIndex }) {
        if (columnIndex < 2) {
            if (rowIndex % 3 === 0) {
            return {
                rowspan: 3,
                colspan: 1
            };
            } else {
            return {
                rowspan: 0,
                colspan: 0
            };
            }
        }

        // if (columnIndex == 15 || columnIndex == 16) {
        //     // console.log("row",row);
        //     // console.log("column",column);
        //     // console.log("rowIndex",rowIndex);
        //     if (rowIndex > 0) {
        //     return {
        //         rowspan: 2,
        //         colspan: 1
        //     };
        //     } else {
        //     return {
        //         rowspan: 1,
        //         colspan: 1
        //     };
        //     }
        // }

        // if (columnIndex > 16 ) {
        //     if (rowIndex % 3 === 0) {
        //     return {
        //         rowspan: 3,
        //         colspan: 1
        //     };
        //     } else {
        //     return {
        //         rowspan: 0,
        //         colspan: 0
        //     };
        //     }
        // }
      },
      formatPrice(val){
			return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(val);
		},
        formatDate(val, format){
            return moment(val).local().format(format)
        },
        formatNumber(value) {
			// let val = (value/1).toFixed(2).replace('.', ',')
			return value.toLocaleString('id-ID')
		},
        async paginateReport(page) {
            this.currentPage = page
            await this.loadReport(this.currentPage)
        },
        async downloadExcel(){
            this.loadingExport = true
            await this.loadReport(1, 'download', { search_by: this.searchField, search: this.searchTerm })
            this.loadingExport = false
        },
        // async loadWA() {
        //   // this.loadingNumber = true
        //   let custId = this.$route.params.consumen
        //   await api({
        //     method: 'post',
        //     url: config.baseApi +'user/'+custId+'/detail_number'
        //   }).then(result => {
        //     // console.log(result.data)
        //     this.number = result.data.data
        //     this.selectedPhone = this.number[0]
        //     this.loadReport()
        //   }).catch(error => {
        //     this.$swal(this.$t('error'), error.message, "error")
        //   })
        //   // this.loadingNumber = false
        // },
        changeFilter() {
            this.currentPage = 1
			this.loadReport(this.currentPage)
		},
        changeFilterCompare() {
            // this.currentPage = 1
			this.loadCompare()
		},
        mergeNoDuplicates(...arrays) {
            let mergedArray = [];
    
            arrays.forEach(array => {
                mergedArray = [...mergedArray, ...array]
            });
    
            const mergedUnique = mergedArray
                .filter((item, index) => 
                    mergedArray.indexOf(item) === index);
            return mergedUnique;
        },
        async loadCompare(){

            if(this.filterChart2 == 'phone'){
                if (!this.selectedStartDate1 || !this.selectedStartDate1[0] || !this.selectedStartDate1[1] || !this.input1 || !this.input2) {
                    this.$message.error({
                        showClose: false,
                        message: 'All field filter is required'
                    });
                    return
                }
            }
            else{
                if (!this.selectedStartDate1 || !this.selectedStartDate1[0] || !this.selectedStartDate1[1] || !this.selectedStartDate2 || !this.selectedStartDate2[0] || !this.selectedStartDate2[1] || !this.input1 || !this.input2) {
                    this.$message.error({
                        showClose: false,
                        message: 'All field filter is required'
                    });
                    return
                }
            }

            let param = {
                    type: this.selectedTypeField,
                    filter: this.selectedFieldCompare,
                    compare: this.filterChart2,
                    "date1":this.selectedStartDate1,
                    param1: this.input1,
                    param2: this.input2
                }
            
            if (this.filterChart2 == 'date') {
                param.date2 = this.selectedStartDate2
            }
            else{
                param.date2 = this.selectedStartDate1
            }

            this.options.title.text = ''
            this.dataChart1.labels = []
            this.dataChart1.datasets = []
            this.dataChart2.labels = []
            this.dataChart2.datasets = []

            this.loadingReportTable = true
            this.dataChart1.loading = true
            this.dataChart2.loading = true
            let label = ''

            switch (this.selectedTypeField) {
                case 'conversation':
                    label = 'Conversation'
                    
                    break;
                case 'revenue':
                    label = 'Revenue'
                    
                    break;
                case 'ui':
                    label = 'User Initiate'
                    
                    break;
                case 'bi':
                    label = 'Business Initiate'
                    
                    break;
                default:
                    break;
            }

			let apiOptions = {
                url: config.baseApi+ "bussiness/get-top-twenty-compare",
                method: 'get',
                params: param
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                if(res.data.ec == 200){
                    
                    this.options.title.text = label
                    if (this.filterChart2 == 'date') {

                        this.dataChart1.labels = res.data.data.one.length > 0 ? res.data.data.one.map(el => moment(el.date).format("DD/MM/YYYY")) : []
                        this.dataChart1.datasets[0] = {
                            label: this.input1,
                            data: res.data.data.one.length > 0 ? res.data.data.one.map(el => parseInt(el.value)) : [],
                            fill: false,
                            borderColor: 'rgb(75, 192, 192)',
                            tension: 0.1
                        }

                        this.dataChart2.labels = res.data.data.two.length > 0 ? res.data.data.two.map(el => moment(el.date).format("DD/MM/YYYY")): []
                        this.dataChart2.datasets[0] = {
                            label: this.input2,
                            data: res.data.data.two.length > 0 ? res.data.data.two.map(el => parseInt(el.value)) : [],
                            fill: false,
                            borderColor: 'rgb(255, 99, 132)',
                            tension: 0.1
                        }

                    }
                    else {
                        let label1 = res.data.data.one.length > 0 ? res.data.data.one.map(el => el.date) : []
                        let label2 = res.data.data.two.length > 0 ? res.data.data.two.map(el => el.date): []
                        let labels = this.mergeNoDuplicates(label1,label2)
                        this.dataChart1.labels = labels
                        this.dataChart1.labels.sort((date1, date2) => moment(date1) - moment(date2))
                        this.dataChart1.labels = this.dataChart1.labels.length > 0 ? this.dataChart1.labels.map(el => moment(el).format("DD/MM/YYYY")):this.dataChart1.labels

                        this.dataChart1.datasets[0] = {
                            label:  this.input1,
                            data: this.dataChart1.labels.length > 0 ? labels.map(el => {
                                let found = res.data.data.one.find(v => v.date == el)
                                return (found ? parseInt(found.value) : 0)
                            }) : [],
                            fill: false,
                            borderColor: 'rgb(75, 192, 192)',
                            tension: 0.1
                        }

                        this.dataChart1.datasets[1] = {
                            label: this.input2,
                            data: this.dataChart1.labels.length > 0 ? labels.map(el => {
                                let found = res.data.data.two.find(v => v.date == el)
                                return (found ? parseInt(found.value) : 0)
                            }) : [],
                            fill: false,
                            borderColor: 'rgb(255, 99, 132)',
                            tension: 0.1
                        }
                    }

                }
                this.loadingReportTable = false
                this.dataChart1.loading = false
                this.dataChart2.loading = false
            })
            .catch(error => {
                this.loadingReportTable = false
				this.$swal(this.$t('error'), error.message, "error")
                this.dataChart1.loading = false
                this.dataChart2.loading = false
            })
            // this.loadingReportTable = false
        },
        async loadReport(page = 1){

            if (!this.selectedMessageTypeField || !this.selectedFilter || !this.selectedField) {
                this.$message.error({
                    showClose: false,
                    message: 'All field filter is required'
                });
                return
            }

            this.loadingReportTable = true
			let custId = this.$route.params.consumen
			let apiOptions = {
                url: config.baseApi+ "bussiness/active-business",
                method: 'get',
                params: {
                    page: page,
                    type: this.selectedMessageTypeField,
                    month: this.selectedFilter,
                    filter: this.selectedField,
                    search: this.filterSearch || ''
                }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                if(res.data.ec == 200){

                    if (Array.isArray(res.data.data)) {
                        this.tableData = res.data.data
                        this.totalData = res.data.total || 0
                    }
                    else{
                        this.tableData = res.data.data.data
                        this.totalData = res.data.data.total || 0
                    }
                }
                this.loadingReportTable = false
            })
            .catch(error => {
                this.loadingReportTable = false
				this.$swal(this.$t('error'), error.message, "error")
            })
            // this.loadingReportTable = false
        },
        async loadDetail(id = null){

            if (!id) {
                this.$message.error({
                    showClose: false,
                    message: 'waba id not found !'
                });
                return
            }

            this.loadingDetail = true
            this.selectedMessageTypeFieldDetail = ('bi_l7' in this.valueDetail) ? "monthly":""
			let apiOptions = {
                url: config.baseApi+ "bussiness/active-business/" + id,
                method: 'get',
                params: {
                    "startDate":this.valueDetail.startDate,
                    "endDate":this.valueDetail.endDate,
                    l7: ('bi_l7' in this.valueDetail) ? true:null
                }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                if(res.data.ec == 200){
                    if (Array.isArray(res.data.data)) {
                        this.dataDetail = res.data.data
                    }
                    else{
                        this.dataDetail = res.data.data.data
                    }
                        
                }
                else{
                    this.modalDetail = false
                    this.$swal(this.$t('error'), error.message, "error")
                }

                this.loadingDetail = false
            })
            .catch(error => {
                this.loadingDetail = false
                this.modalDetail = false
				this.$swal(this.$t('error'), error.message, "error")
            })
            // this.loadingDetail = false
        }
    },
//    created() {
//         if (!this.loadingReport && !this.selectedPhone) {
//             this.loadWA()
//         }
//     },
    mounted() {
        let d = new Date(2022,2);
        d.setDate(d.getDate()-1);
        
		for(let i = 12; i >= 0; i--){
			// console.log("a", moment().subtract(i, 'month').format("MM YYYY"))
            let data = {
				value: moment().subtract(i, 'month').format("YYYY-MM"),
				label: moment().subtract(i, 'month').format("MMM YYYY")
			}

            if (data.value <  moment(d).format("YYYY-MM")) {
                // data.disabled = true
            }

			this.optionsMonths.push(data) 
		}
        this.filterBy = this.optionsMonths
    },
    watch: {
        dataActive: function() {
            this.tableData = this.dataActive
            if (this.tableData.length == 0) {
                this.totalData = 0
            }
        },
        loadingData: function() {
            this.loadingReportTable = this.loadingData
        },
        type: function() {
            this.selectedMessageTypeField = this.type
        },
        date: function() {
            this.selectedStartDate = this.dateRange
        },
        filter: function() {
            this.selectedFilter = this.filter           
        },
        field: function() {
            this.selectedField = this.field          
        },
    }
}
</script>

<style lang="scss">
.el-table .cell  {
        padding-left:10px !important;
}


</style>